import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { Users } from './pages/UserPage';
import Aibn from './pages/Aibn';
import Bpositive from './pages/Bpositive';
import Maheshwari from './pages/Maheshwari';
import Rmb from './pages/Rmb';
import Bizoprivacy from './pages/Bizoprivacy';
import Visitor from './pages/Visitor';
import BulkUpload from './pages/BulkUpload';



export default function App() {
  return (
    <div>
      <div>
        <Routes>
          <Route path="*" element={<HomePage />} />
          <Route path="/" element={<HomePage />} />
          <Route path="/:userId" element={<Users />} />
          <Route path="/aibn" element={<Aibn />} />
          <Route path="/businesspositive" element={<Bpositive />} />
          <Route path="/meconnect" element={<Maheshwari />} />
          <Route path="/rmb" element={<Rmb />} />
          <Route path="/visitor" element={<Visitor/>} />
          <Route path="/bulkimport" element={<BulkUpload/>} />
          <Route path="/networking-app-policy" element={<Bizoprivacy />} />

        </Routes>
      </div>
    </div>
  );
}
